<template>
  <div id="ticket-page">
    <b-container class="mb-4">
      <b-row align-h="center">
        <b-col cols="12" md="8">
          <div class="user-welcome text-center mt-4" style="overflow:hidden">
            <h4 class="d-inline-block">Investment Slots</h4>
            <p>Search for your investment slot below</p>
          </div>
          <b-row>
            <b-col cols="12" class="mb-4">
              <div
                class="wrapper bg-primary dash-card overflow-hidden position-relative"
                style="height:150px"
              >
                <div class="ticket-left h-100 w-75 p-4 float-left text-white">
                  <h4>You have {{ numberOfTickets }} investment slot(s)</h4>
                  <b-form style="bottom:0px" @submit="search">
                    <b-input-group label="Search">
                      <b-form-input
                        v-model="q"
                        type="text"
                        placeholder="Slot Code"
                      ></b-form-input>
                    </b-input-group>
                  </b-form>
                </div>
                <div
                  class="ticket-right bg-white h-100 w-25 float-left position-relative p-2 pt-4"
                >
                  <div class="barcode"></div>
                </div>
              </div>
            </b-col>
            <b-col cols="12">
              <TicketsTable :q="q" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import TicketsTable from "./components/TicketsTable";
import { UserService } from "@/services";

export default {
  data() {
    return {
      q: "",
      numberOfTickets: 0
    };
  },
  components: {
    TicketsTable
  },
  methods: {
    search(event) {
      event.preventDefault();
    }
  },
  created() {
    const numberOfTickets = this.$route.meta.__data;
    this.numberOfTickets = numberOfTickets;
  },
  async beforeRouteEnter(to, from, next) {
    const { data } = await UserService.getNoOfSlots();
    to.meta.__data = data;
    next();
  }
};
</script>

<style lang="scss">
.ticket-left {
  border-right: 1px dashed rgba($color: #000000, $alpha: 0.1);
}

.ticket-right:before,
.ticket-right:after {
  content: "";
  position: absolute;
  display: block;
  width: 0.9em;
  height: 0.9em;
  background: #f7fafc;
  border-radius: 50%;
  left: -0.5em;
}

.ticket-right {
  &:before {
    top: -0.4em;
  }
  &:after {
    bottom: -0.4em;
  }
}

.barcode {
  bottom: 0;
  height: 2em;
  width: 0;
  //   margin: 1.2em 0 0 0.8em;
  box-shadow: 1px 0 0 1px #343434, 5px 0 0 1px #343434, 10px 0 0 1px #343434,
    11px 0 0 1px #343434, 15px 0 0 1px #343434, 18px 0 0 1px #343434,
    22px 0 0 1px #343434, 23px 0 0 1px #343434, 26px 0 0 1px #343434,
    30px 0 0 1px #343434, 35px 0 0 1px #343434, 37px 0 0 1px #343434,
    41px 0 0 1px #343434, 44px 0 0 1px #343434, 47px 0 0 1px #343434,
    51px 0 0 1px #343434, 56px 0 0 1px #343434, 59px 0 0 1px #343434,
    64px 0 0 1px #343434, 68px 0 0 1px #343434, 72px 0 0 1px #343434,
    74px 0 0 1px #343434, 77px 0 0 1px #343434, 81px 0 0 1px #343434;
}
</style>
